import {
  GET_ASSOCIATION_LIST,
  GET_ASSOCIATION_LIST_FAILURE,
  GET_ASSOCIATION_LIST_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getAssociationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ASSOCIATION_LIST:
      return { ...state, loading: true };
    case GET_ASSOCIATION_LIST_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_ASSOCIATION_LIST_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getAssociationReducer;
